module.exports = __webpack_public_path__ + "static/meteor-ddc08563aaddd683e2680f391768e536.png";